import { getLocale } from '../../i18n';

type LegalDoc = 'terms' | 'privacy' | 'cookie';

const cache = new Map<string, string>();

export async function loadLegalBody(doc: LegalDoc): Promise<string> {
  const lng = getLocale();
  const key = `${doc}:${lng}`;
  if (cache.has(key)) return cache.get(key)!;

  const mod = await import(`../../locales/legal/${doc}.${lng}.html?raw`);
  const body = mod.default as string;
  cache.set(key, body);
  return body;
}

export function clearLegalCache(): void {
  cache.clear();
}
